import React from 'react';
import MobileDevPageVideoStagePrimis from './primis/MobileDevPageVideoStage';
const MobileDevPageVideoStage = ({ safety ='off'  })=>{
    return /*#__PURE__*/ React.createElement(MobileDevPageVideoStagePrimis, {
        safety: safety
    });
};
MobileDevPageVideoStage.displayName = 'MobileDevPageVideoStage';
export default MobileDevPageVideoStage;
